export default "__VITE_ASSET__DcZh5IqT__"